import { motion } from "framer-motion";
import { VALUES } from "@/lib/site-data";
import { Check } from "lucide-react";

export default function About() {
  return (
    <section data-testid="about-section" id="about" className="py-24 lg:py-32 bg-[#F4F9FC]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-7"
        >
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">About Agroya</div>
          <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#0A0A0A]">
            Precision refining. <br /> Uncompromising integrity.
          </h2>
          <p className="mt-6 text-[#4B5563] text-base lg:text-lg leading-relaxed">
            Agroya Refinery LLP is committed to delivering the highest standards of purity, quality, ethics and
            customer satisfaction. With advanced refining technology, experienced professionals and stringent
            quality control systems, we provide comprehensive precious metal refining solutions while maintaining
            complete transparency throughout every stage of the refining process.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 gap-6">
            <div className="p-6 bg-white border border-[#E5E5E5] rounded-lg">
              <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Our Vision</div>
              <p className="mt-3 text-sm text-[#0A0A0A] leading-relaxed">
                To become one of India's most trusted precious metal refining companies.
              </p>
            </div>
            <div className="p-6 bg-white border border-[#E5E5E5] rounded-lg">
              <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Our Mission</div>
              <p className="mt-3 text-sm text-[#0A0A0A] leading-relaxed">
                Deliver international quality precious metal refining with uncompromising integrity and precision.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="lg:col-span-5"
        >
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Core Values</div>
          <h3 className="font-heading mt-3 text-2xl font-medium text-[#0A0A0A]">What we stand for</h3>
          <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {VALUES.map((v, i) => (
              <li
                key={v}
                data-testid={`value-${i}`}
                className="flex items-start gap-3 p-4 bg-white rounded-md border border-[#E5E5E5] lift-card"
              >
                <span className="w-6 h-6 rounded-full bg-[#FAF3DF] flex items-center justify-center shrink-0">
                  <Check className="w-3.5 h-3.5 text-[#D4AF37]" strokeWidth={2} />
                </span>
                <span className="text-sm text-[#0A0A0A] font-medium">{v}</span>
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
